export const REPORT_ERROR = {
  TIMEOUT: 'REPORT_TIMEOUT',
  SIZE_LIMIT: 'REPORT_EXCEEDED_SIZE_LIMIT',
  MISSING_GATEWAY: 'MISSING_REPORT_API_GATEWAY',
  GATEWAY_ERROR: 'REPORT_GATEWAY_ERROR',
  INTERNAL_ERROR: 'REPORT_INTERNAL_ERROR',
};
